import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusProgramFragment = { readonly __typename?: 'SyncableEpocusProgram', readonly id: string, readonly name: string, readonly status: Types.EpocusProgramStatus, readonly elephantFacilityId?: string | null, readonly dimseAeTitle?: string | null, readonly turnaroundTargetMinutes?: number | null, readonly enabledExamTypes: ReadonlyArray<Types.EpocusExamType>, readonly worksheetSet: Types.EpocusWorksheetSet, readonly clinicalSetting: Types.EpocusProgramClinicalSetting, readonly billingModifierOverride?: Types.EpocusBillingModifierOverride | null, readonly enabledDeviceIds: ReadonlyArray<string>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusProgramPullQueryVariables = Types.Exact<{
  input: Types.PullMyEpocusProgramsInput;
}>;


export type SyncEpocusProgramPullQuery = { readonly __typename?: 'Query', readonly pullMyEpocusPrograms: { readonly __typename?: 'PullMyEpocusProgramsResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusProgram', readonly id: string, readonly name: string, readonly status: Types.EpocusProgramStatus, readonly elephantFacilityId?: string | null, readonly dimseAeTitle?: string | null, readonly turnaroundTargetMinutes?: number | null, readonly enabledExamTypes: ReadonlyArray<Types.EpocusExamType>, readonly worksheetSet: Types.EpocusWorksheetSet, readonly clinicalSetting: Types.EpocusProgramClinicalSetting, readonly billingModifierOverride?: Types.EpocusBillingModifierOverride | null, readonly enabledDeviceIds: ReadonlyArray<string>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusProgramFragmentDoc = gql`
    fragment WholeSyncableEpocusProgram on SyncableEpocusProgram {
  id
  name
  status
  elephantFacilityId
  dimseAeTitle
  turnaroundTargetMinutes
  enabledExamTypes
  worksheetSet
  clinicalSetting
  billingModifierOverride
  enabledDeviceIds
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusProgramPullDocument = gql`
    query SyncEpocusProgramPull($input: PullMyEpocusProgramsInput!) {
  pullMyEpocusPrograms(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusProgram
    }
  }
}
    ${WholeSyncableEpocusProgramFragmentDoc}`;

/**
 * __useSyncEpocusProgramPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusProgramPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusProgramPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusProgramPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusProgramPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusProgramPullQuery, SyncEpocusProgramPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusProgramPullQuery, SyncEpocusProgramPullQueryVariables>(SyncEpocusProgramPullDocument, options);
      }
export function useSyncEpocusProgramPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusProgramPullQuery, SyncEpocusProgramPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusProgramPullQuery, SyncEpocusProgramPullQueryVariables>(SyncEpocusProgramPullDocument, options);
        }
export type SyncEpocusProgramPullQueryHookResult = ReturnType<typeof useSyncEpocusProgramPullQuery>;
export type SyncEpocusProgramPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusProgramPullLazyQuery>;
export type SyncEpocusProgramPullQueryResult = Apollo.QueryResult<SyncEpocusProgramPullQuery, SyncEpocusProgramPullQueryVariables>;